module.exports = __webpack_public_path__ + "img/vertical_6_5_3009.dcca9e01.png";